var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"basePanel",staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("欢迎使用 HR系统")])])}
var staticRenderFns = []

export { render, staticRenderFns }